import { render } from "./ReportQuickDiagnosisSelectionTab.vue?vue&type=template&id=19b8b48e&scoped=true"
import script from "./ReportQuickDiagnosisSelectionTab.vue?vue&type=script&lang=js"
export * from "./ReportQuickDiagnosisSelectionTab.vue?vue&type=script&lang=js"

import "./ReportQuickDiagnosisSelectionTab.vue?vue&type=style&index=0&id=19b8b48e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19b8b48e"]])

export default __exports__